import { render } from "./DarkMode.vue?vue&type=template&id=d9107482&scoped=true"
import script from "./DarkMode.vue?vue&type=script&lang=js"
export * from "./DarkMode.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d9107482"

export default script